'use client';

import { c as _c } from "react/compiler-runtime";
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import { SxProps, styled, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next/pages';
import { ReactElement, ReactNode } from 'react';
const Card = styled(MuiCard)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px'
  },
  boxShadow: 'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  ...theme.applyStyles('dark', {
    boxShadow: 'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px'
  })
}));
const Container = styled(Stack)(({
  theme
}) => ({
  height: '100dvh',
  padding: 20,
  backgroundImage: 'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
  backgroundRepeat: 'no-repeat',
  ...theme.applyStyles('dark', {
    backgroundImage: 'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))'
  })
}));
interface CenterPageProps {
  children: ReactNode;
}
export function CenterPage(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const {
    t
  } = useTranslation("apps-videos-admin");
  let t1;
  if ($[0] !== children) {
    t1 = <Card variant="outlined" data-testid="CenterPageCard">{children}</Card>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "#C52D3A",
      cursor: "pointer"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("Privacy Policy");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Button size="small"><Typography variant="body2" sx={t2} component="a" href="https://www.cru.org/us/en/about/privacy.html" target="_blank" rel="noopener noreferrer">{t3}</Typography></Button>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <Container direction="column" justifyContent="space-evenly" data-testid="CenterPageContainer"><Stack alignItems="center" gap={5}>{t1}{t4}</Stack></Container>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}